/*
Author : Raphaël Dardeau


Markup : 

<ul data-templating="#tpl" data-templating-json="datas.json">
</ul>
<script id="tpl" type="text/html">
mustache template
</script>


Setup : 

$(function() {
    $("[data-templating]").templating();
});
*/
;(function ($, window, document, undefined) {
    "use strict"; 

    var pluginName = "templating",
        defaults = {
            pagesLimit: -1,
            callback: function() {}
        };

    function Plugin (element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {
        init: function () {
            this.setElements();
            this.setVars();
            if (this.jsonUrl.indexOf('[n]') != -1) {
                this.loadPage();
                this.setEvents();
            } else {
                this.loadContent();
            }
        },
        setElements: function() {
            this.$element = $(this.element);
            this.$window = $(window);
        },
        setVars: function() {
            this.tplId = this.$element.data("templating");
            this.tpl = $(this.tplId).html();
            $(this.tplId).remove();
            this.jsonUrl = this.$element.data("templating-json");
            this.pagesLimit = this.settings.pagesLimit;
            this.page = 0;
            this.contentTop = 0;
            this.contentHeight = 0;
            this.nbLoadedElements = 0;
            this.nbTotalElements = 0;
        },
        loadContent: function() {
            this.$element.addClass("is-loading");
            Mustache.parse(this.tpl);
            if (typeof this.jsonUrl == 'string') {
                $.getJSON(this.jsonUrl, $.proxy(function (json) {
                    var html = Mustache.render(this.tpl, json);
                    this.$element.append(html);
                    this.$element.removeClass("is-loading");
                    this.settings.callback();
                }, this));
            } else {
                var html = Mustache.render(this.tpl, this.jsonUrl);
                this.$element.append(html);
                this.$element.removeClass("is-loading");
                this.settings.callback();
            }
        },
        loadPage: function() {
            this.$element.addClass("is-loading");
            var pageurl = this.jsonUrl.replace('[n]', (this.page + 1));
            $.getJSON(pageurl, $.proxy(function (json) {
                this.nbTotalElements = json.total_items;
                Mustache.parse(this.tpl);
                var html = Mustache.render(this.tpl, json.items);
                this.$element.append(html);
                this.contentTop = this.$element.offset().top;
                this.nbLoadedElements = this.$element.children().length;
                this.$element.removeClass("is-loading");
                this.settings.callback();
                this.page++;
                $(json.items).each(function(i, item) {
                    if (item.type) {// hack for social widgets
                        if (item.type == 'tweet') {
                            cmp.getCmpConsent('purpose', cmp.getKeyForPurpose('essentials')).then(function (consent) {
                                if (consent) {
                                    $.getScript("//platform.twitter.com/widgets.js");
                                    
                                    setTimeout(function() {
                                        twttr.widgets.load();
                                    }, 1 * 1000)
                                }
                            })
                        } else if (item.type == 'instagram') {
                            cmp.getCmpConsent('purpose', cmp.getKeyForPurpose('essentials')).then(function (consent) {
                                if (consent) {
                                    $.getScript("http://platform.instagram.com/fr_FR/embeds.js");
                                }
                            })
                        }
                    }
                });
            }, this));
        },
        setEvents: function() {
            this.$window.on("scroll", $.proxy(function() {
                if (this.nbLoadedElements < this.nbTotalElements && !this.$element.hasClass("is-loading") && (this.page < this.pagesLimit || this.pagesLimit == -1)) {
                    var scrollTop = this.$window.scrollTop();
                    var windowHeight = this.$window.height();
                    this.contentHeight = this.$element.height();
                    if (scrollTop + windowHeight >= this.contentTop + this.contentHeight)                        
                        this.loadPage();
                }
            }, this));
        }
    });

    $.fn[ pluginName ] = function (options) {
        this.each(function() {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
        return this;
    };

})(jQuery, window, document);